import { UNIT, mainColor } from '../../constants/theme';

export const styles = () => ({
  progress: {
    margin: UNIT * 2,
    textAlign: 'center',
    color: mainColor.secondaryColor,
    marginTop: UNIT * 1.25,
    marginBottom: UNIT * 1.25
  },
  body: {
    width: '100%',
    display: 'flex',
    padding: UNIT * 0.625
  },

  subtitle: { fontWeight: 'bold' },
  designText: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bold',
    alignSelf: 'center',
    paddingBottom: '5px'
  },
  bottomNavig: {
    border: '1px solid #f2efef',
    height: UNIT * 7.375,
    borderRadius: UNIT * 0.375,
    marginTop: UNIT * 0.75
  },
  iconStyle: {
    marginBottom: UNIT * 0.8125
  },
  prductIcon: {
    fontSize: UNIT * 5.875,
    opacity: 0.3
  },
  buttonStyle: {
    width: '100%'
  },
  divStyle: {
    height: UNIT * 4.375
  },
  inputStyle: {
    width: '100%'
  },
  cropStyle: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: UNIT * 0.625,
    marginLeft: -UNIT * 0.75
  },
  space: {
    marginTop: UNIT * 0.125,
    marginBottom: `${UNIT * 3.625}%`
  },
  spaceStructure: {
    marginTop: UNIT * 0.125,
    marginBottom: `${UNIT * 3.3125}%`
  },
  helpIcon: {
    color: '#009973',
    fontSize: UNIT * 1.1875
  },
  iconOpacity: {
    width: UNIT * 1.4375
  },
  container: {
    borderRadius: '0px 0px 16px 0px!important',
    height: UNIT * 26.375,
  },
  containerStyle: {
    borderRadius: '0px 0px 16px 0px!important',
    height: UNIT * 28.1875,
    overflow: 'auto'
  },
  root: {
    width: '100%',
    position: 'relative',
    overflow: 'auto',
    maxHeight: UNIT * 21.25
  },
  textStyle: {
    fontSize: UNIT,
    marginTop: -UNIT * 0.625
  },
  listHeaderStyle: {
    background: 'white',
    fontStyle: 'normal',
    fontWeight: 600,
    color: '#858585'
  },
  resize: {
    fontSize: UNIT * 0.875
  },
  crop: {
    width: '100%',
    height: UNIT * 10.1875,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },

  dividerStyle: {
    marginTop: UNIT * 0.625,
    marginBottom: UNIT * 0.625
  },
  myOrdersStyle: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: UNIT * 0.625,
    marginLeft: -UNIT * 0.75,
    width: UNIT * 14.25
  },
  paperStyle: {
    margin: UNIT
  },
  iconColor: {
    color: 'gray'
  },
  loadingProduct: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '52vh'
  },
});
